import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import LOOKUP_TYPES from '../../common/constants/SuccessPlanConstants';
import { request } from '../../common/util/RestClient';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';
import envConfig from '../../config';
import {
  fetchKPIProgressLookupsV2,
  fetchKPIsV2,
  fetchKPIByIdV2,
  createKPIV2,
  editKPIV2,
  archiveKPIV2,
} from '../routines/successPlanRoutines';

const SUCCESS_PLAN_BASE_URL = `${envConfig.APIG_URL}success-plan`;

function* fetchKPIsSagaV2({ payload }) {
  try {
    const { successPlanId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/kpi`;
    const response = yield call(request, url);
    yield put(fetchKPIsV2.success(response.data));
  } catch (error) {
    yield put(fetchKPIsV2.failure({ error }));
  } finally {
    yield put(fetchKPIsV2.fulfill());
  }
}
function* fetchKPIByIdSagaV2({ payload }) {
  try {
    const { successPlanId, kpiId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/kpi/${kpiId}`;
    const response = yield call(request, url);
    yield put(fetchKPIByIdV2.success(response.data));
  } catch (error) {
    yield put(fetchKPIByIdV2.failure({ error }));
  } finally {
    yield put(fetchKPIByIdV2.fulfill());
  }
}

function* createKPISagaV2({ payload }) {
  try {
    const { successPlanId, kpi, onSuccess } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/kpi`;
    const {
      collaborators,
      targetCriteria,
      targetType,
      ownerId,
      startDate,
      dueDate,
      kpiName,
      targetValue,
      startValue,
      currentKpiValue,
      linkAttribute,
    } = kpi;
    const config = {
      method: 'POST',
      payload: {
        kpiName,
        startDate: startDate.format('YYYY-MM-DD'),
        dueDate: dueDate.format('YYYY-MM-DD'),
        ownerId,
        collaborators,
        targetDetails: {
          customColumnId: !linkAttribute ? null : linkAttribute,
          targetType,
          targetCriteria,
          targetValue,
          startValue,
          currentKpiValue,
        },
      },
    };
    const response = yield call(request, url, config);
    yield put(
      createKPIV2.success({
        ...response.data,
        successMessage: SUCCESS_MESSAGES.ADD_SUCCESS_PLAN_KPI,
      })
    );

    if (onSuccess) {
      onSuccess();
    }

    yield put(
      fetchKPIsV2.trigger({
        successPlanId,
      })
    );
  } catch (error) {
    yield put(createKPIV2.failure({ error }));
  } finally {
    yield put(createKPIV2.fulfill());
  }
}
function* editKPISagaV2({ payload }) {
  try {
    const { kpi, successPlanId, kpiId, onSuccess } = payload;
    const {
      collaborators,
      targetCriteria,
      targetType,
      ownerId,
      startDate,
      dueDate,
      kpiName,
      targetValue,
      startValue,
      currentKpiValue,
      progressId,
      linkAttribute,
    } = kpi;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/kpi/${kpiId}`;
    const config = {
      method: 'PUT',
      payload: {
        kpiName,
        progressId,
        startDate: startDate.format('YYYY-MM-DD'),
        dueDate: dueDate.format('YYYY-MM-DD'),
        ownerId,
        collaborators,
        targetDetails: {
          customColumnId: !linkAttribute ? null : linkAttribute,
          targetType: !targetType ? null : targetType,
          targetCriteria: !targetCriteria ? null : targetCriteria,
          targetValue: !targetValue ? 0 : targetValue,
          startValue: !startValue ? 0 : startValue,
          currentKpiValue: !currentKpiValue ? 0 : currentKpiValue,
        },
      },
    };
    const response = yield call(request, url, config);
    yield put(
      editKPIV2.success({
        ...response.data,
        successMessage: SUCCESS_MESSAGES.EDIT_SUCCESS_PLAN_KPI,
      })
    );
    yield put(
      fetchKPIsV2.trigger({
        successPlanId,
      })
    );

    if (onSuccess) {
      onSuccess();
    }

    yield put(
      fetchKPIByIdV2.trigger({
        successPlanId,
        kpiId,
      })
    );
  } catch (error) {
    yield put(editKPIV2.failure({ error }));
  } finally {
    yield put(editKPIV2.fulfill());
  }
}

function* fetchKPIProgressLookupsSagaV2() {
  try {
    const url = `${SUCCESS_PLAN_BASE_URL}/lookup?type=${LOOKUP_TYPES.KPI_PROGRESS}`;
    const response = yield call(request, url);
    yield put(fetchKPIProgressLookupsV2.success(response.data));
  } catch (error) {
    yield put(fetchKPIProgressLookupsV2.failure({ error }));
  } finally {
    yield put(fetchKPIProgressLookupsV2.fulfill());
  }
}

function* archiveKPISagaV2({ payload }) {
  const { successPlanId, kpiId, onSuccess } = payload;
  try {
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/kpi/${kpiId}/archive`;
    const response = yield call(request, url, { method: 'PATCH', payload: {} });
    yield put(fetchKPIsV2.trigger({ successPlanId }));
    if (onSuccess) {
      onSuccess();
    }
    yield put(
      archiveKPIV2.success({
        ...response.data,
        successMessage: SUCCESS_MESSAGES.ARCHIVE_SUCCESS_PLAN_KPI,
      })
    );
  } catch (error) {
    yield put(archiveKPIV2.failure({ error }));
  } finally {
    yield put(archiveKPIV2.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(
      fetchKPIProgressLookupsV2.TRIGGER,
      fetchKPIProgressLookupsSagaV2
    ),
    takeLatest(fetchKPIsV2.TRIGGER, fetchKPIsSagaV2),
    takeLatest(fetchKPIByIdV2.TRIGGER, fetchKPIByIdSagaV2),
    takeEvery(createKPIV2.TRIGGER, createKPISagaV2),
    takeEvery(editKPIV2.TRIGGER, editKPISagaV2),
    takeLatest(archiveKPIV2.TRIGGER, archiveKPISagaV2),
  ]);
}
